<template>
  <div>
    <div class="mt-3" style="width: 100%; margin-left: 10px; margin-right: 10px">
      <b-button-group
        v-for="(option, index) in options"
        :key="index"
      >
        <b-button
          @click="saveMark(option)"
          size=lg
          circle
          variant="outline-success"
          style="font-size: 10px;
               border-radius: 100%;
               height: 27px;
               width: 27px;
               padding: 5px 8px 5px 5px;
               margin: 3px;"
        >
          <i>
            {{ index + 1 }}
          </i>

        </b-button>
      </b-button-group>
    </div>
    <!--    <b-form-radio-group-->
    <!--      v-model="selected"-->
    <!--      :options="options"-->
    <!--      class="mb-3"-->
    <!--      value-field="item"-->
    <!--      text-field="item"-->
    <!--      disabled-field="notEnabled"-->
    <!--    ></b-form-radio-group>-->
    <!--    <div class="mt-3">Selected: <strong>{{ selected.item }} - {{ selected.name }}</strong></div>-->
    <!--    <b-button size="sm" variant="primary" @click="saveMark">Принять</b-button>-->
  </div>
</template>

<script>
export default {
  name: 'marks-list',
  data() {
    return {
      selected: {},
      options: [
        {item: '1', name: 'Неудовлетворительно'},
        {item: '2', name: 'Почти удовлетворительно'},
        {item: '3', name: 'Удовлетворительно'},
        {item: '4', name: 'Весьма удовлетворительно'},
        {item: '5', name: 'Хорошо'},
        {item: '6', name: 'Весьма хорошо'},
        {item: '7', name: 'Очень хорошо'},
        {item: '8', name: 'Почти отлично'},
        {item: '9', name: 'Отлично'},
        {item: '10', name: 'Превосходно'},
      ]
    }
  },

  methods: {
    saveMark(item) {
      // this.$emit('saveMark')
      this.selected = item
      this.$emit('selectMark', this.selected.item)
    }
  }
}
</script>

<style>

</style>
